const cleanCloneData = {
  newAutoAccountMode: true,
  anchorEl: null,
  accountID: "",
  password: "",
  accessOptions: [
    { name: "Enabled", isChecked: false },
    { name: "Web Access", isChecked: false },
  ],
  provisionOptions: [
    { name: "Sports", isChecked: false },
    { name: "Horses", isChecked: false },
    { name: "Casino", isChecked: false },
    { name: "Parlay", isChecked: false },
  ],
  creditLimit: 0,
  phoneLimitMin: 5,
  phoneLimitMax: 300,
  webLimitMin: 5,
  webLimitMax: 300,
  settleFigure: 0,
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
};
const initialState = {
  processingClone: false,
  showSelectSubAgent: true,
  openClonedPlayerFeedback: false,
  openClonedSubAgent: false,
  cloneErrors: [],
  cloneResult: {
    Account: "",
    IdPlayer: 0,
    Password: "",
  },
  clonePlayerData: { ...cleanCloneData },
  suggestData: {
    account: "",
    available: 0,
    data: [],
    prefix: "",
  },
  selectedPlayer: {},
  loadedPlayer: false,
  subAgentSearchData: {
    IdAgent: "0",
    Agent: "",
    SubAgents: [],
  },
  selectedSubAgent: 0,
  selectedSubAgentName: "",
};

export default initialState;
